import { render, staticRenderFns } from "./_products.tab.vue?vue&type=template&id=01d21fd2&scoped=true"
import script from "./_products.tab.vue?vue&type=script&lang=js"
export * from "./_products.tab.vue?vue&type=script&lang=js"
import style0 from "./_products.tab.vue?vue&type=style&index=0&id=01d21fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d21fd2",
  null
  
)

export default component.exports